// Surface corporelle (SC) en m², taille en cm et poids en kg.
// Mosteller (1987) : √(taille × poids ÷ 3600), la plus utilisée.
export const mosteller = (h, w) => Math.sqrt((h * w) / 3600);
// Du Bois et Du Bois (1916) : 0,007184 × poids^0,425 × taille^0,725.
export const duBois = (h, w) => 0.007184 * w ** 0.425 * h ** 0.725;
// Haycock (1978), validée chez l'enfant : 0,024265 × poids^0,5378 × taille^0,3964.
export const haycock = (h, w) => 0.024265 * w ** 0.5378 * h ** 0.3964;

// Bornes larges (nouveau-né à adulte de grande taille) : au-delà, erreur de saisie probable.
export function validate({ height, weight }) {
  return { height: height >= 30 && height <= 250, weight: weight >= 0.5 && weight <= 300 };
}
